import { Route, Switch } from 'react-router-dom';
import { ImportsRoutes } from './imports/_config';
import RedirectHelper from './RedirectHelper';
export const baseLink = '';

export function RootRoutes() {
  return (
    <Switch>
      <Route exact path="/" component={RedirectHelper} />
      <Route path="/:workspaceId" component={ImportsRoutes} />
    </Switch>
  );
}

/**
 * @template {string} Step
 * @template {Record<Step, (options?: object)=> string>} Links
 * @param {Links} links
 * @param {Step[]} order
 * @param {Step} step
 * @returns
 */
export function getStepLinks(links, order, step) {
  const linkList = order.map((key) => links[key]);
  const currentIndex = order.indexOf(step);
  if (currentIndex === -1) throw new Error(`Invalid navigation step ${step}`);
  return {
    _all: links,
    name: step,
    back: linkList[currentIndex ? currentIndex - 1 : currentIndex],
    current: linkList[currentIndex],
    next: linkList[currentIndex + 1],
    cancel: linkList[0],
  };
}
